<template>
    <div>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-width="80">
            <FormItem label="工单类型" prop="selectListId">
                <Select v-model="formValidate.selectListId" style="width:200px">
                    <Option v-for="item in selectListA" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formValidate: {
                selectListId: "",
            },
            ruleValidate: {
                name: [
                    { required: true, message: 'The name cannot be empty', trigger: 'blur' }
                ],
            }
        }
    },
    props: ["row", "selectListA", "toCheckData1"],
    methods: {
        handleSubmit(name) {
            console.log(this.$refs[name]);
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$emit("toCheckData1", this.formValidate.selectListId)
                } else {
                    this.$Message.error('提交失败');
                }
            })
        },
    }
}
</script>

<style></style>